"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RealizedReferralStatus = exports.AddReferralNoteRequest = exports.RealizedReferral = exports.ReferralToken = exports.PromotionCode = exports.TokenId = exports.NewCustomerId = exports.ReferrerCustomerId = void 0;
const z = require("zod");
exports.ReferrerCustomerId = z.number();
exports.NewCustomerId = z.number();
exports.TokenId = z.string();
exports.PromotionCode = z.string();
exports.ReferralToken = z.object({
    tokenId: exports.TokenId,
    customerId: exports.ReferrerCustomerId,
    promotionCode: exports.PromotionCode,
});
const RealizedReferralId = z.string();
exports.RealizedReferral = z.object({
    _id: RealizedReferralId,
    customerId: exports.NewCustomerId,
    referrerId: exports.ReferrerCustomerId,
    promotionCode: exports.PromotionCode,
    tokenId: exports.TokenId,
    note: z.string().optional(),
    handled: z.boolean(),
});
exports.AddReferralNoteRequest = z.object({
    id: RealizedReferralId,
    note: z.string(),
});
exports.RealizedReferralStatus = z.enum(['all', 'unhandled']);
//# sourceMappingURL=Referral.js.map